import KEYS from './key';
import DEVICE from './device';
import PROTOCOL from './protocol';
import { CONNECT_TYPE, CONNECT_STATUS, SCAN_STATUS } from './connect';
import { REQUEST_STATUS } from './request';
import { UPLOAD_STATUS } from './upload';
import { LOGIN_AVAILABLE_BLOCKS, LOGIN_BLOCKS_BELONGTO_EXT } from './blocks';


// 项目后缀
const PROJECT_SUFFIX = ['mblock', 'json', 'sb2', 'sb3'];
const PROJECT_ACCEPT = ['application/mblock', 'application/json', 'application/sb2', 'application/sb3'];
// 角色后缀
const SPRITE_SUFFIX = ['svg', 'png', 'jpg'];
// 用户自定义角色上传图片格式
const SPRIET_ACCEPT = ['image/jpeg', 'image/png', 'image/svg+xml'];
// 用户自定义上传声音格式
const SPRIET_SOUNDS_ACCEPT = ['audio/mp3', 'audio/wav'];
// 用户自定义角色文件名前缀
const SPRITE_FILE_PREFIX = 'U_';
// 上传时显示编译的设备
const SHOW_COMPILING_DEVICE = ['mcore', 'auriga'];

// 同步连接状态的的操作类型
const SYNC_CONNECT_STATE_TYPE = {
    ONREADY: 0,
    PROJECT: 1,
    ADD_DEVICE: 2,
    REMOVE_DEVICE: 3,
    CONNECTED: 4,
    SERVER_OFFLINE: 5,
    CONNECT_BROKEN: 6
};

// 传感器校正类型
const SENSOR_CALIBRATE_TYPE = {
    // 颜色传感器
    COLOR: 'color',
    // 陀螺仪
    GYRO: 'gyro'
};

// 角色类型
const SPRITE_TYPE = {
    // 角色库
    LIBS: 'libs',
    USER_LIBS: 'user_libs',
    // 造型库
    COSTUMES: 'costumes',
    // 造型库
    USER_COSTUMES: 'user_costumes',
    // 音效库
    SOUNDS: 'sounds',
    USER_SOUNDS: 'user_sounds',
    // 背景库
    BACKDROPS: 'backdrops',
    USER_BACKDROPS: 'user_backdrops',
    // 硬件设备
    DEVICES: 'devices'
};

// 作品状态
const PROJECT_STATUS = {
    // 正常
    NORMAL: 0,
    // 待下载
    WILL_DOWNLOAD: 1,
    // 待上传文件
    WILL_UPLOAD_FILE: 2,
    // 待上传记录
    WILL_UPLOAD_RECORD: 3,
    // 待上传文件和记录
    WILL_UPLOAD_ALL: 4,
    // 上传中
    UPLOADING: 5,
    // 待删除
    WILL_DELETE: 6
};

// 作品类型
const PROJECT_TYPE = {
    // 示例
    EXAMPLE: 'example',
    // 从本地打开
    LOCAL: 'local',
    // 从我的作品打开
    LIST: 'list'
};

// 作品保存状态
const PROJECT_SAVE_STATUS = {
    DOING: 'DOING',
    FAILURE: 'FAILURE',
    SUCCESS: 'SUCCESS'
};

// 作品列表同步状态
const PROJECT_SYNC_STATUS = {
    SYNCING: 'syncing',
    SUCCESS: 'success',
    FAIL: 'fail',
    NONETWORK: 'noNetWork'
};

// 作品保存超时时间
const PROJECT_SAVE_TIMEOUT = 60000;

export default {
    ...KEYS,
    DEVICE,
    PROTOCOL,
    REQUEST_STATUS,
    UPLOAD_STATUS,
    CONNECT_TYPE,
    CONNECT_STATUS,
    SCAN_STATUS,
    PROJECT_ACCEPT,
    PROJECT_SUFFIX,
    LOGIN_AVAILABLE_BLOCKS,
    LOGIN_BLOCKS_BELONGTO_EXT,
    SYNC_CONNECT_STATE_TYPE,
    SENSOR_CALIBRATE_TYPE,
    SHOW_COMPILING_DEVICE,
    SPRITE_SUFFIX,
    SPRITE_TYPE,
    SPRIET_ACCEPT,
    SPRIET_SOUNDS_ACCEPT,
    SPRITE_FILE_PREFIX,
    PROJECT_STATUS,
    PROJECT_TYPE,
    PROJECT_SAVE_STATUS,
    PROJECT_SYNC_STATUS,
    PROJECT_SAVE_TIMEOUT
};